import { z } from "zod";

export type JSONLiteral = z.infer<typeof JSONLiteralSchema>;
export const JSONLiteralSchema = z.union([z.string(), z.number(), z.boolean(), z.null()]);

export type JSON = JSONLiteral | { [key: string]: JSON } | JSON[];
export const JSONSchema: z.ZodType<JSON> = z.lazy(() =>
  z.union([JSONLiteralSchema, z.record(JSONSchema), z.array(JSONSchema)]),
);
